import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import LinkSpecialtyDetail from '@components/common/Link/LinkSpecialtyDetail';
import LoadingNavigation from '@components/common/Loading/LoadingNavigation';
import DepartmentService from '@services/department.service';
import {useAuth} from '@contexts/AuthProvider';

export default function ListSpecialty() {
    const {lang} = useAuth();
    const {locale} = useRouter();
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAll, setShowAll] = useState(false);

    const loadListSpecialty = async () => {
        const departmentService = new DepartmentService();
        try {
            setLoading(true);
            const response = await departmentService.getDepartment({locale: locale});
            if (Array.isArray(response)) setDepartments(response);
            else if (response?.data && Array.isArray(response.data)) setDepartments(response.data);
            else setDepartments([]);
        } catch (error) {
            console.error('Lỗi khi tải danh sách chuyên khoa:', error);
            setDepartments([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadListSpecialty();
    }, [locale]);

    if (loading) {
        return (
            <section className="specialty-section">
                <h2 className="specialty-title">{getLocaleContent(locale, 'page.specialty-page.all-specialties')}</h2>
                <div className="specialty-loading">
                    <LoadingNavigation size="large" />
                    <p>{getLocaleContent(locale, 'page.specialty-page.loading')}</p>
                </div>
            </section>
        );
    }

    if (!departments || departments.length === 0) return null;

    const itemsToShow = showAll ? departments : departments.slice(0, 6); // Hiển thị 6 phần tử đầu

    return (
        <section className="specialty-section">
            <h2 className="specialty-title">{getLocaleContent(locale, 'page.specialty-page.all-specialties')}</h2>

            <div className="specialty-grid">
                {itemsToShow.map((dep, index) => (
                    <LinkSpecialtyDetail key={dep.department_id || dep.id || index} department={dep}>
                        <div className="specialty-list-card" style={{cursor: 'pointer'}}>
                            <div className="specialty-list-image">
                                <img src={dep.image_url || dep.image} alt={dep.department_name || dep.name} />
                            </div>
                            <div className="specialty-list-info">
                                <h3>{dep.department_name || dep.name}</h3>
                                <div className="specialty-link">
                                    <span>{getLocaleContent(locale, 'page.specialty-page.view-detail')} →</span>
                                </div>
                            </div>
                        </div>
                    </LinkSpecialtyDetail>
                ))}
            </div>

            {/* Nút xem thêm */}
            {!showAll && departments.length > 6 && (
                <button type="button" className="load-more" onClick={() => setShowAll(true)}>
                    {getLocaleContent(locale, 'page.specialty-page.view-more') || 'Xem thêm'}
                    <img src="/bw_image/chevron-down-double.svg" alt="" />
                </button>
            )}
        </section>
    );
}
